import { Fragment, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router";
import { Button, Form, Modal, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loading from "../../Common/Loading";
import SidePanel from "../../Components/SidePanel/SidePanel";
import Paginations from "../../Components/Paginations/Paginations";
import FilePageService from "../../API/FilePage/FilePageService";
import { BiPlus } from "react-icons/bi";
import Select from "react-select";
import LogicalBlockService from "../../API/LogicalBlock/LogicalBlockService";

const QuestionsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [questionBasisList, setQuestionBasisList] = useState([]);
  const [showQuestionBasisList, setShowQuestionBasisList] = useState([]);
  const [logoImageShow, setLogoImageShow] = useState("");
  const [rightPanelThemeColor, setRightPanelThemeColor] = useState("#d9ebff");
  const [editQuestionBasisId, setEditQuestionBasisId] = useState("");
  const [editQuestionBasis, setEditQuestionBasis] = useState(false);
  const [editQuestionBasisStatus, setEditQuestionBasisStatus] = useState("");
  const [riskTypeFilter, setRiskTypeFilter] = useState("");
  const [logicalBlockFilter, setLogicalBlockFilter] = useState("");
  const [updateQuestionBasisId, setUpdateQuestionBasisId] = useState("");
  const [updateQuestionBasisStatus, setUpdateQuestionBasisStatus] =
    useState("");
  const [deleteQuestionBasisId, setDeleteQuestionBasisId] = useState("");
  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [sort, setSort] = useState({ key: "created_at", value: "desc" });
  const [isRotated, setIsRotated] = useState(false);

  const [riskTypeList, setRiskTypeList] = useState([]);
  const [logicalBlockOptions, setLogicalBlockOptions] = useState([]);
  const [logicalBlockList, setLogicalBlockList] = useState([]);

  const [questions, setQuestions] = useState([
    {
      id: Date.now(),
      risk_type: "",
      logical_block_id: "",
      question_text: "",
      input_type: "",
      options: [""],
      is_required: "0",
      subQuestions: [],
    },
  ]);

  const [formShow, setFormShow] = useState(false);
  const handleFormShow = () => {
    setFormShow(true);
    setQuestions([
      {
        id: Date.now(),
        risk_type: "",
        logical_block_id: "",
        question_text: "",
        input_type: "",
        options: [""],
        is_required: "0",
        subQuestions: [],
      },
    ]);
  };
  const handleFormClose = () => {
    setFormShow(false);
    setQuestions([
      {
        id: Date.now(),
        risk_type: "",
        logical_block_id: "",
        question_text: "",
        input_type: "",
        options: [""],
        is_required: "0",
        subQuestions: [],
      },
    ]);
  };

  const [showmodal, setShowmodal] = useState(false);
  const handleModalShow = () => setShowmodal(true);
  const handleModalClose = () => {
    setShowmodal(false);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const [search, setSearch] = useState("");

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const token = localStorage.getItem("authToken");
    if (token && userRole.includes("Administrateur")) {
      const logo_image = JSON.parse(localStorage.getItem("logo_image"));
      const right_panel_color = JSON.parse(
        localStorage.getItem("right_panel_color")
      );
      setRightPanelThemeColor(right_panel_color);
      setLogoImageShow(logo_image);
      QuestionBasisList(search, sort, currentPage, editQuestionBasisStatus, riskTypeFilter, logicalBlockFilter);
      setEditQuestionBasisStatus("");
    } else {
      navigate("/");
    }
  }, [sort]);

  useEffect(() => {
    let sort = {
      key: "created_at",
      value: "desc"
    }
    RiskTypeList();
    LogicalBlockList(sort, 1, "");
  }, []);

  const RiskTypeList = async () => {
    try {
      const response = await FilePageService.risk_types_list();

      if (response.data.status) {
        setRiskTypeList(response.data.risk_types);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const LogicalBlockList = async (sort, page = 1, status) => {
    setIsLoading(true);
    try {
      const useData = {
        sort: {
          key: sort.key,
          value: sort.value
        },
        page,
        status: status,
      };

      const response = await LogicalBlockService.logical_block_list(useData);

      if (response.data.status) {
        setIsLoading(false);
        setLogicalBlockList(response.data.LogicalBlocks.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const LogicalBlockByRiskType = async (riskTypeId) => {
    try {
      if (!riskTypeId) return [];

      const userData = { risk_type: riskTypeId };
      const response = await FilePageService.logical_block_by_risk_type(userData);

      const logicalData = response?.data?.LogicalBlocks || [];

      return logicalData.map(item => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      console.error("Error fetching logical blocks:", error);
      return [];
    }
  };

  const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
    value: key,
    label: label,
  }));

  const QuestionBasisList = async (search, sort, page = 1, status, riskType, logicalBlock) => {
    setIsLoading(true);
    try {
      const useData = {
        search,
        sort: {
          key: sort.key,
          value: sort.value,
        },
        page,
        status: status,
        risk_type: riskType,
        logical_block: logicalBlock
      };

      const response = await FilePageService.question_list(useData);

      if (response.data.status) {
        setIsLoading(false);
        setQuestionBasisList(response.data.questions_list.data);
        setCurrentPage(response.data.questions_list.meta.current_page);
        setTotalPages(response.data.questions_list.meta.last_page);
        setTotalRecord(response.data.questions_list.meta.total);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const NewQuestionBasisCreate = async (e) => {
    e.preventDefault();

    for (let i = 0; i < questions.length; i++) {
      const q = questions[i];
      if (!q.question_text || !q.input_type) {
        setFlashMessage({
          type: "error",
          message: t("requriedErrorMessageLabel"),
        });
        return;
      }
    }

    const payload = questions.map((q) => {
    const questionPayload = {
      risk_type: q.risk_type.toString(),
      ...(q.logical_block_id ? { logical_block_id: q.logical_block_id } : {}),
      question_text: q.question_text,
      input_type: q.input_type,
      is_required: q.is_required,
      sub_questions: q.subQuestions.map((sub) => ({
        question_text: sub.question_text,
        input_type: sub.input_type,
        trigger_option: sub.trigger_option,
      })),
    };

    if (q.input_type === "select" && Array.isArray(q.options) && q.options.length > 0) {
      questionPayload.options = q.options;
    }

      return questionPayload;
    });


    try {
      const response = await FilePageService.create_question(payload);

      if (response.data.status) {
        setFlashMessage({
          type: "success",
          message: "Questions created successfully!",
        });
        setFormShow(false);
        setLogicalBlockOptions([]);
        QuestionBasisList(search, sort, 1, "", "", "");
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message:
          error.response?.data?.message || "Something went wrong while saving.",
      });
    }
  };

  const ShowQuestionBasis = async (e, id) => {
    e.preventDefault();
    setEditQuestionBasisId(id);
    try {
      const response = await FilePageService.show_question(id);

      if (response.data.status) {
        const qData = response.data.data;

        const selectedRiskType = riskTypeOptions.find(
          (option) => option.value.toString() == qData.risk_type?.toString()
        );
        
        const blocks = await LogicalBlockByRiskType(selectedRiskType.value);
        
        setLogicalBlockOptions(blocks);
        
        const selectedLogicalBlock = blocks?.find(
          (option) => option.value == qData.logical_block_id
        );

        const mappedQuestions = [
          {
            id: qData.id,
            risk_type: selectedRiskType?.value,
            ...(selectedLogicalBlock ? { logical_block_id: selectedLogicalBlock?.value } : {}),
            question_text: qData.question_text,
            input_type: qData.input_type,
            is_required: qData.is_required.toString(),
            options: qData.options.map((opt) => opt.option_text),
            subQuestions: qData.sub_questions.map((sub) => ({
              id: sub.id,
              question_text: sub.question_text,
              input_type: sub.input_type,
              trigger_option: sub.trigger_option || "",
            })),
          },
        ];
        setShowQuestionBasisList(mappedQuestions);
        setQuestions(mappedQuestions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const EditQuestionBasis = async (e) => {
    e.preventDefault();

    if (!questions || questions.length === 0) {
      setFlashMessage({
        type: "error",
        message:
          t("requriedErrorMessageLabel") || "Please add at least one question",
      });
      return;
    }

    const userData = questions?.[0];

    const payload = {
      id: userData.id,
      risk_type: userData?.risk_type,
      ...(userData.logical_block_id ? { logical_block_id: userData.logical_block_id } : {}),
      question_text: userData.question_text ?? "",
      input_type: userData.input_type ?? "",
      is_required: userData.is_required === "1" ? 1 : 0,
      sub_questions: userData.subQuestions.map((sub) => ({
        id: sub.id,
        question_text: sub.question_text ?? "",
        input_type: sub.input_type ?? "",
        trigger_option: sub.trigger_option ?? null,
      })),
    };

    if (userData.input_type === "select" && Array.isArray(userData.options) && userData.options.length > 0) {
      payload.options = userData.options;
    }

    try {
      const response = await FilePageService.edit_question(
        editQuestionBasisId,
        payload
      );

      if (response.data.status) {
        setFormShow(false);
        setLogicalBlockOptions([]);
        QuestionBasisList(search, sort, currentPage, "", "", "");
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message:
          error.response?.data?.message ||
          t("somethingWentWrong") ||
          "Something went wrong",
      });
    }
  };

  const DeleteQuestionBasis = async () => {
    try {
      const response = await FilePageService.delete_question(
        deleteQuestionBasisId
      );

      if (response.data.status) {
        QuestionBasisList(search, sort, 1, "", "", "");
        handleCloseDeleteModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleUpdateStatus = async () => {
    var useData = {
      status: updateQuestionBasisStatus == 1 ? "0" : "1",
    };

    try {
      const response = await FilePageService.questions_status_update(
        updateQuestionBasisId,
        useData
      );

      if (response.data.status) {
        setEditQuestionBasisStatus("");
        QuestionBasisList(search, sort, currentPage, "", "", "");
        handleModalClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    QuestionBasisList(search, sort, 1, editQuestionBasisStatus, riskTypeFilter, logicalBlockFilter);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchChange(search);
    }
  };

  const HandleFilterStatus = (status) => {
    setEditQuestionBasisStatus(status);
    QuestionBasisList(search, sort, 1, status, riskTypeFilter, logicalBlockFilter);
  };

  const HandleLogicalBlockFilter = (logical_block) => {
    setLogicalBlockFilter(logical_block);
    QuestionBasisList(search, sort, 1, editQuestionBasisStatus, riskTypeFilter, logical_block);
  };

  const HandleRiskTypeFilter = (risk_type) => {
    setRiskTypeFilter(risk_type);
    QuestionBasisList(search, sort, 1, editQuestionBasisStatus, risk_type, logicalBlockFilter);
  };

  const handleStatusChange = (id, status) => {
    setUpdateQuestionBasisId(id);
    setUpdateQuestionBasisStatus(status);
    handleModalShow();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    QuestionBasisList(search, sort, page, editQuestionBasisStatus, riskTypeFilter, logicalBlockFilter);
  };

  const handleClickRotate = (column) => {
    const direction =
      sort.key === column ? (sort.value === "desc" ? "asc" : "desc") : "asc";
    setSort({ key: column, value: direction });
    setIsRotated(!isRotated);
  };

  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        id: Date.now(),
        risk_type: "",
        logical_block_id: "",
        question_text: "",
        input_type: "",
        options: [""],
        is_required: "0",
        subQuestions: [],
      },
    ]);
    setLogicalBlockOptions([]);
  };

  const removeQuestion = (id) => {
    setQuestions(questions.filter((q) => q.id !== id));
  };

  const handleQuestionChange = (id, field, value) => {
    setQuestions(
      questions.map((q) =>
        q.id === id
          ? {
              ...q,
              [field]: value,
              ...(field === "input_type" && value !== "select"
                ? { options: [""] }
                : {}),
            }
          : q
      )
    );
  };

  const handleOptionChange = (questionId, index, value) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: q.options.map((opt, i) => (i === index ? value : opt)),
            }
          : q
      )
    );
  };

  const addOptionField = (questionId) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId ? { ...q, options: [...q.options, ""] } : q
      )
    );
  };

  const removeOptionField = (questionId, index) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? { ...q, options: q.options.filter((_, i) => i !== index) }
          : q
      )
    );
  };

  const addSubQuestion = (questionId) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              subQuestions: [
                ...q.subQuestions,
                {
                  id: Date.now(),
                  question_text: "",
                  input_type: "",
                  trigger_option: "",
                },
              ],
            }
          : q
      )
    );
  };

  const removeSubQuestion = (questionId, subId) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              subQuestions: q.subQuestions.filter((s) => s.id !== subId),
            }
          : q
      )
    );
  };

  const handleSubQuestionChange = (questionId, subId, field, value) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              subQuestions: q.subQuestions.map((s) =>
                s.id === subId ? { ...s, [field]: value } : s
              ),
            }
          : q
      )
    );
  };

  return (
    <Fragment>
      <style>
        {" "}
        {` button.btn.btn-primary  { background-color: ${
          localStorage.getItem("button_color")
            ? JSON.parse(localStorage.getItem("button_color"))
            : "#e84455"
        } !Important};`}{" "}
      </style>

      <SidePanel
        sidebarLogo={`${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`}
      />

      <div
        className="dashboard-main-content insurers-dashboard"
        style={{ backgroundColor: rightPanelThemeColor }}
      >
        <div className="top-header">
          {/* <h4>Base de question</h4> */}

          <div className="mt-3 d-md-flex justify-content-between align-items-center">
            <h1 className="m-md-0 mb-3">Liste de base des questions</h1>
          </div>
        </div>

        <div className="table-wrapper mt-24">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Form.Group
              className="relative"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="search"
                placeholder="Rechercher"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={handleKeyPress}
              />
              <div
                className="search-icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleSearchChange(search)}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7549 11.2549H11.9649L11.6849 10.9849C12.6649 9.84488 13.2549 8.36488 13.2549 6.75488C13.2549 3.16488 10.3449 0.254883 6.75488 0.254883C3.16488 0.254883 0.254883 3.16488 0.254883 6.75488C0.254883 10.3449 3.16488 13.2549 6.75488 13.2549C8.36488 13.2549 9.84488 12.6649 10.9849 11.6849L11.2549 11.9649V12.7549L16.2549 17.7449L17.7449 16.2549L12.7549 11.2549ZM6.75488 11.2549C4.26488 11.2549 2.25488 9.24488 2.25488 6.75488C2.25488 4.26488 4.26488 2.25488 6.75488 2.25488C9.24488 2.25488 11.2549 4.26488 11.2549 6.75488C11.2549 9.24488 9.24488 11.2549 6.75488 11.2549Z"
                    fill="#998f90"
                  />
                </svg>
              </div>
            </Form.Group>
            <button
              onClick={() => {
                setShowQuestionBasisList([]);
                setLogicalBlockOptions([]);
                handleFormShow();
                setEditQuestionBasis(false);
              }}
              className="btn btn-primary"
            >
              Ajouter une base de question
            </button>
          </div>

          {isLoading ? (
            <Loading />
          ) : (
            <div className="table-wrap mt-24">
              <Table responsive hover>
                <thead>
                  <tr>
                    {/* <th>No.</th> */}
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Texte de la question")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("question_text")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <div>
                            <Form.Select
                              aria-label="statusSelectAria"
                              value={logicalBlockFilter}
                              onChange={(e) => HandleLogicalBlockFilter(e.target.value)}
                            >
                              <option value="">{t("Bloc logique")}</option>
                              {logicalBlockList?.length > 0 ?
                                logicalBlockList?.map((data) => (
                                  <option key={data.id} value={data.id}>{data.name}</option>
                                )) : (
                                  <option value="">{t("NorecordsfoundLabel")}</option>
                                )
                              }
                            </Form.Select>
                          </div>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("risk_type")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <div>
                            <Form.Select
                              aria-label="statusSelectAria"
                              value={riskTypeFilter}
                              onChange={(e) => HandleRiskTypeFilter(e.target.value)}
                            >
                              <option value="">{t("Type de risque")}</option>
                              {riskTypeOptions?.map((data, index) => (
                                <option key={index} value={data.value}>{data.label}</option>
                              ))}
                            </Form.Select>
                          </div>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("risk_type")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Type d'entrée")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("input_type")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Est requis")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("is_required")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th width={165} className="select-drop elips-dropdown">
                      <div className="d-flex align-items-center">
                        <div>
                          <Form.Select
                            aria-label="statusSelectAria"
                            value={editQuestionBasisStatus}
                            onChange={(e) => HandleFilterStatus(e.target.value)}
                          >
                            <option value="">{t("status")}</option>
                            <option value="0">{t("inActiveLabel")}</option>
                            <option value="1">{t("activeLabel")}</option>
                          </Form.Select>
                        </div>
                        <div>
                          <Link
                            className={`sorting-icon ms-2`}
                            onClick={() => handleClickRotate("status")}
                          >
                            {sort.value === "asc" && (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                  fill="black"
                                />
                                <path
                                  d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                              </svg>
                            )}

                            {sort.value === "desc" && (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                                <path
                                  d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Link>
                        </div>
                      </div>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {questionBasisList?.length > 0 ? (
                    questionBasisList?.map((data, index) => (
                      <tr key={index}>
                        {/* <td>{(currentPage - 1) * 10 + (index + 1)}</td> */}
                        <td>{data.question_text}</td>
                        <td>{data.logical_block ? data.logical_block.name : ""}</td>
                        <td>{data.risk ? data.risk.name : ""}</td>
                        <td>{data.input_type}</td>
                        <td>{data.is_required == true ? "Oui" : "Non"}</td>
                        <td>
                          {data.status == 1 ? (
                            <span
                              className="verified badges"
                              onClick={() =>
                                handleStatusChange(data.id, data.status)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {t("activeLabel")}
                            </span>
                          ) : (
                            <span
                              className="incomplete badges"
                              onClick={() =>
                                handleStatusChange(data.id, data.status)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {t("inActiveLabel")}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="action-btn">
                            <Link
                              className="edit"
                              onClick={(e) => {
                                ShowQuestionBasis(e, data.id);
                                handleFormShow();
                                setEditQuestionBasis(true);
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 6.19L2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19Z"
                                  fill="#e84455"
                                />
                              </svg>
                            </Link>
                            <Link
                              className="delete"
                              onClick={() => {
                                handleShowDeleteModal();
                                setDeleteQuestionBasisId(data.id);
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                  fill="#e84455"
                                />
                              </svg>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ textAlign: "center" }}>
                      <td colSpan="8">{t("NorecordsfoundLabel")}</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
          {totalRecord > 10 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              itemsPerPage={10}
              totalItems={totalRecord}
            />
          )}
        </div>
      </div>

      {/* Add & Edit User Canvas */}
      <Offcanvas
        className="account-request-pannel"
        placement="end"
        show={formShow}
        onHide={handleFormClose}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {editQuestionBasis
              ? "Modifier la base de question"
              : "Ajouter une base de question"}
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Form
            onSubmit={
              editQuestionBasis ? EditQuestionBasis : NewQuestionBasisCreate
            }
          >
            {flashMessage.message && (
              <div
                className={`mt-3 mx-w-620 alert ${
                  flashMessage.type === "success"
                    ? "alert-success"
                    : "alert-danger"
                } text-center`}
                role="alert"
              >
                {flashMessage.message}
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Questions</h5>
              {!editQuestionBasis && (
                <Button
                  variant="success"
                  className="d-flex align-items-center gap-2"
                  onClick={addQuestion}
                >
                  <BiPlus size={20} />
                  Ajouter une question
                </Button>
              )}
            </div>

            {questions.map((q, qIndex) => (
              <div key={q.id} className="p-3 mb-4 border rounded">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Question {qIndex + 1}</h6>
                  {questions?.length > 1 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeQuestion(q.id)}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                          fill="#e84455"
                        />
                      </svg>
                    </Button>
                  )}
                </div>

                {/* Risk Type */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    Type de risque <span>*</span>
                  </Form.Label>
                  <Select
                    options={riskTypeOptions}
                    value={riskTypeOptions.find(
                      (option) => option.value == q.risk_type
                    )}
                    onChange={async (selectedOption) => {
                      setQuestions((prev) => {
                        const updated = [...prev];
                        updated[qIndex] = {                    
                          ...updated[qIndex],
                          risk_type: selectedOption.value,
                          logical_block_id: null,
                        };
                        return updated;
                      });
                      const blocks = await LogicalBlockByRiskType(selectedOption.value);
                      setLogicalBlockOptions(blocks);
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "100%",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: "100%",
                      }),
                    }}
                    placeholder={"Sélectionnez le type de risque"}
                    isSearchable={true}
                    noOptionsMessage={() => t("NorecordsfoundLabel")}
                  />
                </Form.Group>

                {/* Logical Blocks */}
                {logicalBlockOptions.length > 0 && (
                  <Form.Group className="mb-3">
                    <Form.Label>Bloc logique</Form.Label>
                    <Select
                      options={logicalBlockOptions}
                      value={logicalBlockOptions.find(
                        (option) => option.value == q.logical_block_id
                      )}
                      onChange={(selectedOption) => {
                        setQuestions((prev) => {
                          const updated = [...prev];
                          updated[qIndex] = {
                            ...updated[qIndex],
                            logical_block_id: selectedOption.value,
                          };
                          return updated;
                        });
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                      }}
                      placeholder={"Sélectionnez le bloc logique"}
                      isSearchable={true}
                      noOptionsMessage={() => t("NorecordsfoundLabel")}
                    />
                  </Form.Group>
                )}

                {/* Question Text */}
                <Form.Group controlId={`question_text_${q.id}`}>
                  <Form.Label>
                    Question <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Saisir une question"
                    value={q.question_text}
                    onChange={(e) =>
                      handleQuestionChange(
                        q.id,
                        "question_text",
                        e.target.value
                      )
                    }
                  />
                </Form.Group>

                {/* Input Type */}
                <Form.Group controlId={`input_type_${q.id}`} className="mt-3">
                  <Form.Label>
                    Type d'entrée <span>*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={q.input_type}
                    onChange={(e) =>
                      handleQuestionChange(q.id, "input_type", e.target.value)
                    }
                  >
                    <option value="">Sélectionnez le type d'entrée</option>
                    <option value="text">Texte</option>
                    <option value="number">Nombre</option>
                    <option value="textarea">Zone de texte</option>
                    <option value="file">Déposer</option>
                    <option value="select">Sélectionner</option>
                    {/* <option value="radio">Radio</option> */}
                    {/* <option value="checkbox">Checkbox</option> */}
                  </Form.Control>
                </Form.Group>

                {/* Options */}
                {q.input_type === "select" && (
                  <Form.Group controlId={`options_${q.id}`} className="mt-3">
                    <Form.Label>Options</Form.Label>
                    {q.options.map((opt, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Form.Control
                          type="text"
                          placeholder={`Option ${index + 1}`}
                          value={opt}
                          onChange={(e) =>
                            handleOptionChange(q.id, index, e.target.value)
                          }
                          style={{ flex: 1 }}
                        />

                        {q.options.length > 1 && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            style={{ marginBottom: "15px" }}
                            onClick={() => removeOptionField(q.id, index)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                fill="#e84455"
                              />
                            </svg>
                          </Button>
                        )}
                      </div>
                    ))}

                    <Button
                      variant="success"
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                      onClick={() => addOptionField(q.id)}
                    >
                      <BiPlus size={20} />
                      Ajouter une option
                    </Button>
                  </Form.Group>
                )}

                {/* Is Required */}
                <Form.Group controlId={`is_required_${q.id}`} className="mt-3">
                  <Form.Label>
                    Est-ce obligatoire ? <span>*</span>
                  </Form.Label>
                  <div>
                    <Form.Check
                      inline
                      type="radio"
                      id={`is_required_yes_${q.id}`}
                      label="Oui"
                      name={`is_required_${q.id}`}
                      value="1"
                      checked={q.is_required === "1"}
                      onChange={() =>
                        handleQuestionChange(q.id, "is_required", "1")
                      }
                    />
                    <Form.Check
                      inline
                      type="radio"
                      id={`is_required_no_${q.id}`}
                      label="Non"
                      name={`is_required_${q.id}`}
                      value="0"
                      checked={q.is_required === "0"}
                      onChange={() =>
                        handleQuestionChange(q.id, "is_required", "0")
                      }
                    />
                  </div>
                </Form.Group>

                {/* Sub Questions */}
                {q.input_type == "select" &&
                  <div className="sub-questions mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0">Sous-questions</h6>
                      <Button
                        variant="success"
                        className="d-flex align-items-center gap-2"
                        onClick={() => addSubQuestion(q.id)}
                      >
                        <BiPlus size={20} />
                        Ajouter une sous-question
                      </Button>
                    </div>

                    {q.subQuestions.map((sub, i) => (
                      <div key={sub.id} className="mb-3 p-3 border rounded">
                        <div className="d-flex justify-content-between align-items-center">
                          <Form.Label>Sous-question {i + 1}</Form.Label>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removeSubQuestion(q.id, sub.id)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                fill="#e84455"
                              />
                            </svg>
                          </Button>
                        </div>

                        <Form.Group className="mb-2">
                          <Form.Label>Question</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Saisissez le texte de la question"
                            value={sub.question_text}
                            onChange={(e) =>
                              handleSubQuestionChange(
                                q.id,
                                sub.id,
                                "question_text",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>Type d'entrée</Form.Label>
                          <Form.Control
                            as="select"
                            value={sub.input_type}
                            onChange={(e) =>
                              handleSubQuestionChange(
                                q.id,
                                sub.id,
                                "input_type",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Sélectionnez le type d'entrée</option>
                            <option value="text">Texte</option>
                            <option value="number">Nombre</option>
                            <option value="textarea">Zone de texte</option>
                            <option value="file">Déposer</option>
                            {/* <option value="radio">Radio</option> */}
                            {/* <option value="checkbox">Checkbox</option> */}
                          </Form.Control>
                        </Form.Group>

                        {(q.input_type === "select" ||
                          q.input_type === "radio" ||
                          q.input_type === "checkbox") &&
                          q.options.length > 0 &&
                          q.options.some((opt) => opt.trim() !== "") && (
                            <Form.Group>
                              <Form.Label>Option de déclenchement</Form.Label>
                              <Form.Control
                                as="select"
                                value={sub.trigger_option}
                                onChange={(e) =>
                                  handleSubQuestionChange(
                                    q.id,
                                    sub.id,
                                    "trigger_option",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Sélectionnez l'option de déclenchement</option>
                                {q.options.map((data, index) => (
                                  <option key={index} value={data}>
                                    {data}
                                  </option>
                                ))}
                              </Form.Control>
                            </Form.Group>
                          )}
                      </div>
                    ))}
                  </div>
                }
              </div>
            ))}

            {/* Submit */}
            <div className="canvas-footer text-end mt-3">
              <Button variant="primary" type="submit">
                {t("submitButton")}
              </Button>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Confirmation Popup */}
      <Modal
        className="missing-doc-modal"
        show={showmodal}
        onHide={() => setShowmodal(true)}
      >
        <Modal.Header closeButton onHide={handleModalClose}>
          <Modal.Title>
            <h2>{t("confirmStatusTitle")}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="complete-process">{t("confirmStatusMessage")}</span>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button variant="primary" onClick={() => HandleUpdateStatus()}>
              {t("confirmbtnLabel")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Popup */}
      <Modal
        className="final-modal"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Confirmation</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Êtes-vous sûr de vouloir supprimer le base de question ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cancel-btn"
            variant="primary"
            onClick={handleCloseDeleteModal}
          >
            Annuler
          </Button>
          <Button variant="primary" onClick={DeleteQuestionBasis}>
            {t("confirmbtnLabel")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default QuestionsList;
